export enum LogLevel {
  DEBUG = 10,
  INFO = 20,
  WARN = 30,
  ERROR = 40,
  FATAL = 50,
}

export type LogLevelName = keyof typeof LogLevel;

export interface LogConfig {
  level: LogLevelName;
  console: boolean;
  remote: boolean;
}

export interface LogContext {
  debug(msg: string, data?: unknown): void;
  info(msg: string, data?: unknown): void;
  warn(msg: string, data?: unknown): void;
  error(msg: string, err?: unknown, data?: unknown): void;
  fatal(msg: string, err?: unknown, data?: unknown): void;
}

/** Integration seam for Ticket 2 — optional until ErrorReporterService lands. */
export interface ErrorReporter {
  captureException(error: unknown, context?: Record<string, unknown>): void;
}
